<template>
    <div id="form-section" class="bg-black">
        <div class="relative overflow-hidden text-white form-section" data-aos="fade-up">
            <div class="overlay"></div>
            <div class="form-bg"></div>
            <div class="container relative z-10 px-4 pt-24 pb-12 mx-auto show-on-scroll">
                <div class="mb-6 text-4xl leading-none text-center md:text-5xl title-text">
                    Speak with us today
                </div>
                <div class="w-full mx-auto mb-12 text-center text-4 md:w-10/12">
                    Kindly share with us your query below and we will get back to you soon, <span class="block md:inline-block">or you can call us at <a href="tel:88957955" class="cta-btn">8895 7955</a>.</span> 
                </div>
                <div class="w-full mx-auto mb-12 text-center text-4 md:w-9/12">
                    <!-- feedback.activamedia.com.sg script begins here --><iframe allowTransparency="true" style="min-height:300px; height:inherit; overflow:auto;" width="100%" id="form-iframe" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="https://feedback.activamedia.com.sg/my-contact-form-5472069.html"><p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p></iframe><!-- feedback.activamedia.com.sg script ends here -->
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: #0a5096;
        opacity: 0.75;
        z-index: 1;
    }

    video {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        z-index: 0;
        -ms-transform: translateX(-50%) translateY(-50%);
        -moz-transform: translateX(-50%) translateY(-50%);
        -webkit-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        max-width: unset;
    }

    .form-bg {
        background-image: url(/images/form-bg.jpg);
        background-size: cover;
        background-position: top center;
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        height: auto;
        z-index: 0;
        -ms-transform: translateX(-50%) translateY(-50%);
        -moz-transform: translateX(-50%) translateY(-50%);
        -webkit-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        max-width: unset;
    }

    iframe {
        min-height: 845px !important;
    }
    @media (min-width: 400px) {
        iframe {
            min-height: 620px !important;
        }
    }
</style>

<script>
export default {
}
</script>